import React from 'react'
import './styles.scss'

type Props = {}

const BottomLine = (props: Props) => {
  return (
    <div className='bottom-line'></div>
  )
}

export default BottomLine;